module.exports = __webpack_public_path__ + "img/图1-30锥度的标注及画法.0245fde2.png";